import CommonModal from "../../common/CommonModal";
import CustomerTrainingsTab from "./CustomerTrainingsTab";

type Props = {
  open: boolean;
  onClose: () => void;
  customerId: number;
  customerName?: string;
};

export default function CustomerTrainingsModal({ open, onClose, customerId, customerName }: Props) {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={customerName ? `Formations – ${customerName}` : "Formations"}
      size="xl"
      fitContentHeight
    >
      <CustomerTrainingsTab customerId={customerId} />
    </CommonModal>
  );
}
